import React from 'react'

import JourneyBuilderIframe from '../JourneyBuilderIframe'

export default function CreateIframe() {
  return (
    <JourneyBuilderIframe subRoute='list' />
  )
}



// WEBPACK FOOTER //
// ./src/routes/JourneyBuilder/JourneyListing/JourneyListing.js